"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'CreateCustomerModal',
  props: {
    isModalActive: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  emits: ['submit', 'onClose'],
  data: function data() {
    return {
      form: this.createDefaultForm()
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    farm: 'GET_FARM'
  })), {}, {
    isEdit: function isEdit() {
      var _this$customer;
      return Boolean((_this$customer = this.customer) === null || _this$customer === void 0 ? void 0 : _this$customer.id);
    }
  }),
  watch: {
    isModalActive: function isModalActive(active) {
      if (active) {
        this.form = this.createDefaultForm(this.customer);
      }
    },
    customer: {
      handler: function handler(newValue) {
        if (this.isModalActive) {
          this.form = this.createDefaultForm(newValue);
        }
      },
      deep: true
    }
  },
  methods: {
    createDefaultForm: function createDefaultForm() {
      var _customer$name, _customer$cpfCnpj;
      var customer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return {
        name: (_customer$name = customer === null || customer === void 0 ? void 0 : customer.name) !== null && _customer$name !== void 0 ? _customer$name : '',
        cpfCnpj: (_customer$cpfCnpj = customer === null || customer === void 0 ? void 0 : customer.cpfCnpj) !== null && _customer$cpfCnpj !== void 0 ? _customer$cpfCnpj : ''
      };
    },
    sanitizeDocument: function sanitizeDocument(value) {
      return (value || '').replace(/\D/g, '').slice(0, 14);
    },
    handleClose: function handleClose() {
      this.form = this.createDefaultForm();
      this.$emit('onClose');
    },
    submitForm: function submitForm() {
      var _this$farm, _this$customer$id, _this$customer2;
      var name = (this.form.name || '').trim();
      if (name.length < 3) {
        this.$buefy.toast.open({
          message: 'Informe um nome com pelo menos 3 caracteres.',
          type: 'is-danger'
        });
        return;
      }
      var cpfCnpj = this.sanitizeDocument(this.form.cpfCnpj);
      var payload = {
        farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id,
        name: name,
        cpfCnpj: cpfCnpj || null
      };
      this.$emit('submit', {
        id: (_this$customer$id = (_this$customer2 = this.customer) === null || _this$customer2 === void 0 ? void 0 : _this$customer2.id) !== null && _this$customer$id !== void 0 ? _this$customer$id : null,
        payload: payload
      });
    }
  }
};